// declare global {
//   interface Window {
//     facebookConnectPlugin: any;
//   }
// }

// export interface MetaEventParams {
//   [key: string]: string | number | boolean | null | undefined;
// }

// class MetaEventLoggerClass {

//   appName = 'yumzy-ios'
//   timestamp = Date.now()

//   /** Initialize Facebook SDK (browser only) */
//   init(appId: string, version: string = "v18.0"): void {
//     if (!window.facebookConnectPlugin) {
//       console.warn("Facebook plugin not available yet.");
//       return;
//     }
//   }

//   /** Generic event logger */
//   logEvent(eventName: string, params: MetaEventParams = {}): void {
//     params['appName'] = this.appName;
//     params['timestamp'] = this.timestamp;
//     params['client'] = 'iOS';

//     if (!window.facebookConnectPlugin) {
//       console.warn("Facebook plugin missing → cannot log:", eventName);
//       return;
//     }

//     try {
//       window.facebookConnectPlugin.logEvent(
//         eventName,
//         params,
//         null,
//         () => console.log(`Meta Event Logged: ${eventName}`),
//         (err: any) => console.error(`Event Log Error (${eventName}):`, err)
//       );
//     } catch (err) {
//       console.error("Meta Event Exception:", err);
//     }
//   }

//   //new
//   appForground(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_app_foreground", params);
//   }

//   //new
//   appBackground(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_app_background", params);
//   }

//   //existing
//   viewContent(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_content_view", params);
//   }

//   //new
//   viewOutlet(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_outlet_viewed", params);
//   }

//   //existing
//   addToCart(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_add_to_cart", params);
//   }

//   //existing
//   purchase(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_purchase", params);
//   }

//   //new
//   payClick(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_pay_clicked", params);
//   }

//   //new
//   errorCheckout(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_unable_to_checkout", params);
//   }

//   //new
//   bannerClick(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_top_banner_click", params);
//   }

//   //existing
//   installApp(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_first_app_launch", params);
//   }

//   //new
//   userSignup(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_user_signup", params);
//   }

//   //new
//   search(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_search", params);
//   }

//   //new
//   errorInApp(params: MetaEventParams = {}): void {
//     this.logEvent("fb_mobile_app_error", params);
//   }
// }

// // Export single instance
// const MetaEventLogger = new MetaEventLoggerClass();
// export default MetaEventLogger;


import { isPlatform} from "@ionic/angular";

declare global {
  interface Window {
    facebookConnectPlugin: any;
  }
}

export interface MetaEventParams {
  [key: string]: any;
}

class MetaEventLoggerClass {

  private isReady = false;                     
  private eventQueue: any[] = [];             
  private allowedTypes = ["string", "number", "boolean"]; 

  constructor() {
    document.addEventListener("deviceready", () => {
      this.initPlugin();
    });
  }

  /** Plugin becomes ready AFTER deviceready */
  private initPlugin() {
    if (isPlatform("ios")) {
      if (window.facebookConnectPlugin) {
        console.log("[MetaEventLogger] Plugin ready.");
        this.isReady = true;

        // Flush queued events
        this.eventQueue.forEach(e => this.logEventNow(e.eventName, e.params));
        this.eventQueue = [];
      } else {
        console.warn("[MetaEventLogger] FB plugin NOT available on deviceready!");
      }
    }
  }

  /** Sanitize parameters to avoid Meta rejecting events */
  private sanitizeParams(params: MetaEventParams) {
    const clean: MetaEventParams = {};

    Object.keys(params).forEach(key => {
      const val = params[key];
      const t = typeof val;

      if (val == null) return; // skip null/undefined

      if (this.allowedTypes.includes(t)) {
        clean[key] = val.toString(); // Meta requires primitives or strings
      } else {
        console.warn(`[MetaEventLogger] Dropping unsupported param "${key}" →`, val);
      }
    });

    return clean;
  }

  /** Public method to log event safely */
  logEvent(eventName: string, params: MetaEventParams = {}) {
    if (isPlatform("ios") && isPlatform("cordova")) {
      const cleanedParams = {
        ...this.sanitizeParams(params),
      };

      if (!this.isReady || !window.facebookConnectPlugin) {
        console.warn("[MetaEventLogger] Plugin not ready → QUEUE:", eventName);
        this.eventQueue.push({ eventName, params: cleanedParams });
        return;
      }
      this.logEventNow(eventName, cleanedParams);
    }
  }

  /** Actual native logging method */
  private logEventNow(eventName: string, params: MetaEventParams) {
    try {
      console.log("[MetaEventLogger] Logging event: ", eventName, JSON.stringify(params));
      window.facebookConnectPlugin.logEvent(
        eventName,
        params,
        null,
        () => console.log(`[MetaEventLogger] Logged: ${eventName}`),
        err => console.error(`[MetaEventLogger] ERROR (${eventName})`, err)
      );
    } catch (err) {
      console.error("[MetaEventLogger] Exception:", err);
    }
  }

  // ----------------------------------------
  // Wrapper methods → readable API
  // ----------------------------------------

  // appForeground(p = {}) { this.logEvent("fb_mobile_app_foreground", p); }
  appBackground(p = {}) { this.logEvent("fb_mobile_app_background", p); }
  viewContent(p = {}) { this.logEvent("fb_mobile_content_view", p); }
  viewOutlet(p = {}) { this.logEvent("fb_mobile_outlet_viewed", p); }//done
  addToCart(p = {}) { this.logEvent("AddToCart", {
  content_id: "123",
  content_type: "product",
  currency: "INR",
  value: 199
}); }
  purchase(p = {}) { this.logEvent("fb_mobile_purchase", p); }
  payClick(p = {}) { this.logEvent("fb_mobile_pay_clicked", p); } //done
  errorCheckout(p = {}) { this.logEvent("fb_mobile_unable_to_checkout", p); } //done
  bannerClick(p = {}) { this.logEvent("fb_mobile_top_banner_click", p); } //done
  installApp(p = {}) { this.logEvent("fb_mobile_first_app_launch", p); } //done
  userSignup(p = {}) { this.logEvent("fb_mobile_user_signup", p); }
  search(p = {}) { this.logEvent("fb_mobile_search", p); } //done
  errorInApp(p = {}) { this.logEvent("fb_mobile_app_error", p); }
}

const MetaEventLogger = new MetaEventLoggerClass();
export default MetaEventLogger;
